// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCB4UHI-h3fb3XPRoqZa47sYfIYs4ttDf0",
    authDomain: "if-we-could-all-talk.firebaseapp.com",
    projectId: "if-we-could-all-talk",
    storageBucket: "if-we-could-all-talk.firebasestorage.app",
    messagingSenderId: "604760151730",
    appId: "1:604760151730:web:2e15a8f630e402ee4a5bab",
    measurementId: "G-MPB7254LWQ"
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
